import React from "react";
import Button from "@material-ui/core/Button";
import styled from "styled-components";
import AddIcon from "@material-ui/icons/Add";
const StyledSecondaryButton = styled(Button)`
  &.MuiButton-root {
    background: #ffffff;
    color: #0765ff;
    font-size: 13px;
    line-height: 18px;
    border-radius: 8px;
    height: 40px;
    font-weight: 800;
    border: 1px solid #0765ff;
    text-transform: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0px 10px;
    &:hover {
      background: #f8fbff;
    }
  }
`;

const SecondaryButton = ({ children, showIcon, disabled, icon, ...rest }) => {
  let btnIcon = showIcon
    ? (icon ?? <AddIcon style={{ color: "#0028fa" }} />)
    : null;
  return (
    <>
      <StyledSecondaryButton startIcon={btnIcon} {...rest}>
        {children}
      </StyledSecondaryButton>
    </>
  );
};

export default SecondaryButton;
